"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var send_reminder_modal_html_1 = __importDefault(require("../../../../documents/send-reminder-modal/send-reminder-modal.html"));
var send_reminder_modal_controller_1 = __importDefault(require("../../../../documents/send-reminder-modal/send-reminder-modal.controller"));
var AdminStudentDocumentsController = /** @class */ (function () {
    function AdminStudentDocumentsController($state, $stateParams, $q, $uibModal, UsersModel, DocumentInstanceModel, FlashService) {
        // View state
        this.loading = true;
        this.submitting = false;
        this.student = null;
        this.documents = [];
        // Filtering and pagination
        this.filteringBy = "all";
        this.currentPage = 1;
        this.totalItems = 0;
        this.lastPage = 1;
        this.itemsPerPage = 10;
        // Modal state
        this.showAssignModal = false;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$q = $q;
        this.$uibModal = $uibModal;
        this.UsersModel = UsersModel;
        this.DocumentInstanceModel = DocumentInstanceModel;
        this.FlashService = FlashService;
        // Bind methods that are passed to Vue components
        this.closeAssignModal = this.closeAssignModal.bind(this);
        this.onDocumentAssigned = this.onDocumentAssigned.bind(this);
        this.init();
    }
    Object.defineProperty(AdminStudentDocumentsController.prototype, "isViewingDocument", {
        // Check if viewing a single document (child state)
        get: function () {
            return this.$state.includes('drivecoach.admin.students.view.documents.view');
        },
        enumerable: false,
        configurable: true
    });
    AdminStudentDocumentsController.prototype.init = function () {
        var _this = this;
        this.loading = true;
        var getStudent = this.UsersModel.getStudentByID(this.$stateParams.userId);
        var getDocuments = this.loadDocuments(1, this.filteringBy);
        this.$q.all([getStudent, getDocuments]).then(function (responses) {
            _this.student = responses[0];
            _this.loading = false;
        }).catch(function (error) {
            _this.FlashService.setMessage({ type: "error", message: "Failed to load documents" });
            _this.loading = false;
        });
    };
    AdminStudentDocumentsController.prototype.loadDocuments = function (page, status) {
        var _this = this;
        if (page === void 0) { page = 1; }
        if (status === void 0) { status = "all"; }
        var params = {
            page: page,
            per_page: this.itemsPerPage,
        };
        if (status !== "all") {
            params.status = status;
        }
        return this.DocumentInstanceModel.getUserDocuments(this.$stateParams.userId, params).then(function (response) {
            // Handle both paginated and non-paginated responses
            if (response.data && Array.isArray(response.data)) {
                _this.documents = response.data;
                _this.totalItems = response.data.length;
                _this.lastPage = 1;
                _this.currentPage = 1;
            }
            else if (response.current_page !== undefined) {
                _this.documents = response.data || [];
                _this.currentPage = response.current_page;
                _this.totalItems = response.total;
                _this.lastPage = response.last_page;
            }
            else {
                _this.documents = [];
                _this.totalItems = 0;
            }
        });
    };
    AdminStudentDocumentsController.prototype.filterByStatus = function (status) {
        this.filteringBy = status;
        this.currentPage = 1;
        this.loadDocuments(1, status);
    };
    AdminStudentDocumentsController.prototype.pageChanged = function () {
        this.loadDocuments(this.currentPage, this.filteringBy);
    };
    AdminStudentDocumentsController.prototype.viewDocument = function (document) {
        this.$state.go("drivecoach.admin.students.view.documents.view", {
            userId: this.$stateParams.userId,
            documentId: document.id,
        });
    };
    AdminStudentDocumentsController.prototype.archiveDocument = function (document) {
        var _this = this;
        if (!confirm("Are you sure you want to archive this document?")) {
            return;
        }
        this.submitting = true;
        this.DocumentInstanceModel.archiveDocument(document.id)
            .then(function () {
            _this.FlashService.setMessage({ type: "success", message: "Document archived successfully" });
            _this.loadDocuments(_this.currentPage, _this.filteringBy);
        })
            .catch(function () {
            _this.FlashService.setMessage({ type: "error", message: "Failed to archive document" });
        })
            .finally(function () {
            _this.submitting = false;
        });
    };
    AdminStudentDocumentsController.prototype.sendReminder = function (document) {
        var _this = this;
        this.submitting = true;
        this.DocumentInstanceModel.getDocument(document.id)
            .then(function (response) {
            var _a;
            var fullDocument = ((_a = response.data) === null || _a === void 0 ? void 0 : _a.document) || response.document || response;
            var pendingUsers = (fullDocument.assigned_users || [])
                .filter(function (u) { return u.completion_status !== "completed"; });
            if (pendingUsers.length === 0) {
                _this.FlashService.setMessage({ type: "info", message: "All assigned users have completed their fields" });
                return;
            }
            var modalInstance = _this.$uibModal.open({
                animation: true,
                template: send_reminder_modal_html_1.default,
                controller: send_reminder_modal_controller_1.default,
                controllerAs: "vm",
                size: "md",
                resolve: {
                    document: function () { return fullDocument; },
                    pendingUsers: function () { return pendingUsers; },
                },
            });
            modalInstance.result.then(function () {
                _this.FlashService.setMessage({ type: "success", message: "Reminder sent successfully" });
            }, function () {
                // dismissed
            });
        })
            .catch(function () {
            _this.FlashService.setMessage({ type: "error", message: "Failed to load document details" });
        })
            .finally(function () {
            _this.submitting = false;
        });
    };
    AdminStudentDocumentsController.prototype.openAssignModal = function () {
        this.showAssignModal = true;
    };
    AdminStudentDocumentsController.prototype.closeAssignModal = function () {
        this.showAssignModal = false;
    };
    AdminStudentDocumentsController.prototype.onDocumentAssigned = function () {
        this.closeAssignModal();
        this.loadDocuments(this.currentPage, this.filteringBy);
        this.FlashService.setMessage({ type: "success", message: "Document assigned successfully" });
    };
    AdminStudentDocumentsController.prototype.getStatusBadgeClass = function (status) {
        var classes = {
            pending: "label-warning",
            in_progress: "label-info",
            completed: "label-success",
            archived: "label-default",
        };
        return classes[status] || "label-default";
    };
    AdminStudentDocumentsController.prototype.getStatusLabel = function (status) {
        var labels = {
            pending: "Pending",
            in_progress: "In Progress",
            completed: "Completed",
            archived: "Archived",
        };
        return labels[status] || status;
    };
    AdminStudentDocumentsController.prototype.formatDate = function (dateString) {
        if (!dateString)
            return "";
        var date = new Date(dateString);
        return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
        });
    };
    return AdminStudentDocumentsController;
}());
AdminStudentDocumentsController.$inject = [
    "$state",
    "$stateParams",
    "$q",
    "$uibModal",
    "UsersModel",
    "DocumentInstanceModel",
    "FlashService",
];
exports.default = AdminStudentDocumentsController;
